export default "/assets/dd3a103eb5d94672666de21420d84721.woff";